export const isOdd = (num) => num % 2 === 1;
export const isSSR = typeof window === 'undefined';
